import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "d-flex flex-row nowrap justify-content-md-between px-md-0 mx-md-0",
  id: "details-top"
}
const _hoisted_2 = { class: "d-flex flex-column nowrap w-100 col-12 px-0" }
const _hoisted_3 = { class: "mb-3 mb-md-2 me-0 me-md-2 d-flex flex-row flex-nowrap d-lg-flex" }
const _hoisted_4 = { class: "d-lg-flex flex-row nowrap align-items-md-center text-start me-2 w-100 position-relative" }
const _hoisted_5 = { class: "heading text-grey-900 me-2 mb-0 w-100" }
const _hoisted_6 = { class: "w-100" }
const _hoisted_7 = { class: "d-none d-md-flex justify-content-center position-absolute more-info-button-container" }
const _hoisted_8 = { class: "cursor-pointer plus-d-infos-hanging-btn-wrapper bg-white box-shadow" }
const _hoisted_9 = { class: "button-secondary bg-none border-primary-blue text-primary-blue" }
const _hoisted_10 = { class: "text-nowrap" }
const _hoisted_11 = { class: "d-flex flex-column justify-content-between mt-3" }
const _hoisted_12 = { class: "mb-2" }
const _hoisted_13 = {
  key: 0,
  class: "d-flex flex-row justify-content-between"
}
const _hoisted_14 = {
  key: 0,
  class: "text-md-end me-md-4 mb-2"
}
const _hoisted_15 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_16 = {
  key: 0,
  class: "d-flex flex-row nowrap text-grey-900 position-relative justify-content-between"
}
const _hoisted_17 = { class: "d-flex" }
const _hoisted_18 = {
  key: 0,
  class: "me-2 text-nowrap caption"
}
const _hoisted_19 = {
  key: 0,
  class: "text-md-end me-md-4"
}

import {
	ref,
	Ref,
	computed,
	ComputedRef,
	onMounted,
} from "vue";

// Store
//import store from "@/vue/planning/store/store";

// Components
import PrestationPictureMobile from "@/vue/planning/components/result/prestation/pictureMobile.vue";
import LimitedAvailabilityMessage from "@/vue/planning/components/result/prestation/limitedAvailabilityMessage.vue";
import InfoIcons from "@/vue/planning/components/result/infoIcons.vue";
import PlaceholderBox from "@/vue/planning/components/common/placeholderBox.vue";
import Inclus from "@/vue/planning/components/result/prestation/inclus.vue";
import PackageDetalisPopUp from "@/vue/planning/components/result/prestation/packageDetalisPopUp.vue";

// Logic
import { isPierreVacance } from "@/vue/planning/logic/pv";
import { isCS } from "@/vue/planning/logic/cs";
import { isValidNewSkiPassPackages } from "@/vue/planning/logic/isValidNewSkiPassPackages";

// Types
import { Prestation } from "@/types";


import { useStore } from "vuex"
interface Props {
	prestation: Prestation;
	isDisplayPlaceholders: boolean;
}
interface Emits {
	(e: "plusInfosClick"): void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'detailsTop',
  props: {
    prestation: { default: {} },
    isDisplayPlaceholders: { type: Boolean, default: false }
  },
  emits: ["plusInfosClick"],
  setup(__props: any, { emit: __emit }) {

const store = useStore();

const props = __props;
const emit = __emit;

// computed
const reference = computed(() => {
	const variants = props.prestation.variants;
	if (!variants) return;

	if (variants[0]["pvFlex"]) {
		const nonFlexVariant = variants.find((prest: any) => {
			return prest.pvFlex === "nonflex";
		});

		return nonFlexVariant.prestIdSource;
	}

	return variants[0].prestIdSource;
});

const isHSProduct = computed(() => {
	return props.prestation.variants[0].codePackage === "HS";
});

const lowestQuantity = computed(() => {
	const variants = props.prestation.variants;
	if (!variants) return;
	variants.sort((a: any, b: any) => a.quantity - b.quantity);
	return variants[0].quantity;
});


const image: ComputedRef<string> = computed(() => {
	const images = props.prestation?.picturesAccomodation || [];
	if (images.length === 0) return "";

	const img = images[0];
	return (
		img["imgSmall"] ||
		img["imgMedium"] ||
		img["imgLarge"] ||
		img["imgXL"] ||
		img["img"] ||
		""
	);
});


// methods
const handlePlusDinfosClick = () => {
	emit("plusInfosClick");
};

/**
 * Determines if the stay is considered short based on specific conditions.
 *
 * This function checks if the first variant meets the CS condition 
 * (i.e., if it is not a CS variant or if it is a CS variant and is Pierre Vacance).
 * It also checks if the ski pass conditions for the new ski pass pacakges are valid.
 *
 * @returns {boolean} True if both the CS condition and the ski pass condition are met, indicating a short stay, false otherwise.
 */
const isShortStay=():boolean=> {
	const variants = props.prestation.variants;
	const firstVariant = variants[0];

	const CScondition = (!isCS(firstVariant) || (isCS(firstVariant) && isPierreVacance(firstVariant)))

	const skiPassCondition = !isValidNewSkiPassPackages(variants)


	return (CScondition && skiPassCondition);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h3", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, [
              _createElementVNode("span", null, [
                (_ctx.isDisplayPlaceholders)
                  ? (_openBlock(), _createBlock(PlaceholderBox, {
                      key: 0,
                      height: '25px',
                      width: '300px',
                      additionalClasses: 'mb-2'
                    }))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(props.prestation.accomodationName), 1)
                    ], 64))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  (_ctx.isDisplayPlaceholders)
                    ? (_openBlock(), _createBlock(PlaceholderBox, {
                        key: 0,
                        height: '25px',
                        width: '100px'
                      }))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_unref(store).state.content.planner_prestationsMoreInfo), 1)
                      ], 64))
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode(PrestationPictureMobile, {
        onPlusInfosClick: handlePlusDinfosClick,
        isDisplayPlaceholders: _ctx.isDisplayPlaceholders,
        src: image.value
      }, null, 8, ["isDisplayPlaceholders", "src"]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(InfoIcons, {
            isDisplayPlaceholders: _ctx.isDisplayPlaceholders,
            prestation: props.prestation
          }, null, 8, ["isDisplayPlaceholders", "prestation"])
        ]),
        (props.prestation.variants && 
						!_unref(isPierreVacance)(props.prestation.variants[0]))
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              (_ctx.isDisplayPlaceholders)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createVNode(LimitedAvailabilityMessage, {
                      isDisplayPlaceholders: _ctx.isDisplayPlaceholders,
                      quantity: lowestQuantity.value
                    }, null, 8, ["isDisplayPlaceholders", "quantity"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      (
					props.prestation.variants 
				)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            (isShortStay())
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    (!_ctx.isDisplayPlaceholders && _unref(store).state.packCode !== 'HS')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                          _createTextVNode(_toDisplayString(_unref(store).state.content.planner_prestationsInclude) + " ", 1),
                          _cache[0] || (_cache[0] = _createElementVNode("svg", { class: "icon info-icon tf-icon-10 tf-icon-sm-20" }, [
                            _createElementVNode("use", { "xlink:href": "#___icon___info" })
                          ], -1)),
                          _cache[1] || (_cache[1] = _createTextVNode(" : ")),
                          _createVNode(PackageDetalisPopUp, { top: '0' }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).getters.packageInfoContent, (content, content_i) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  key: `${content[0]}-${content_i}}`
                                }, _toDisplayString(content), 1))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(Inclus, {
                      isPierreVacance: 
								props.prestation.variants &&
								_unref(isPierreVacance)(props.prestation.variants[0])
							,
                      isDisplayPlaceholders: _ctx.isDisplayPlaceholders,
                      variant: props.prestation.variants[0]
                    }, null, 8, ["isPierreVacance", "isDisplayPlaceholders", "variant"])
                  ]),
                  (_ctx.isDisplayPlaceholders)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createVNode(LimitedAvailabilityMessage, {
                          isDisplayPlaceholders: _ctx.isDisplayPlaceholders,
                          quantity: lowestQuantity.value
                        }, null, 8, ["isDisplayPlaceholders", "quantity"])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})